import gql from 'graphql-tag';

export const GET_PROPOSAL_STATUSES_OPTIONS = gql`
  query GetProposalStatuses {
    proposalStatuses {
      label
      value
    }
  }
`;
